import React, { useState } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { ImageToggle as ImageToggleType } from '../../types/heroTextSection'
import Image from './Image'

interface Props {
  toggle: ImageToggleType
}

const ImageToggle: React.FC<Props> = ({ toggle }) => {
  const { classes } = useStyles()
  const [toggleValue, setToggleValue] = useState<number | null>(0)
  const handleToggle = (
    event: React.MouseEvent<HTMLElement>,
    newToggleValue: number | null
  ) => {
    setToggleValue(newToggleValue)
  }

  return (
    <Box className={classes.box}>
      <ToggleButtonGroup
        aria-label="Toggle"
        className={classes.toggleButtonGroup}
        exclusive
        onChange={handleToggle}
        value={toggleValue}
      >
        {toggle.toggleLabels.map((label, index) => (
          <ToggleButton
            aria-label={label}
            classes={{
              root: classes.toggleButton,
              selected: classes.toggleButtonSelected,
            }}
            key={index}
            value={index}
            disableRipple
          >
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {typeof toggleValue === 'number' && (
        <Image
          asset={toggle.images[toggleValue]}
          className={classes.image}
          objectFit="contain"
        />
      )}
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  box: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  image: {
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 .25rem .94rem 0 rgba(211, 211, 211, 0.5)',
    height: 'auto',
    width: '100%',
    margin: '1.63em 0 .57em',
    maxWidth: 'unset',
    maxHeight: 'unset',
    '& img': {
      height: 'unset !important',
    },
  },
  toggleButton: {
    backgroundColor: theme.palette.divider,
    border: 'none',
    borderRadius: '1.5em !important',
    color: theme.palette.text.disabled,
    fontSize: '.81em',
    margin: '0 .25rem',
    padding: '.69em .5em',
    textTransform: 'unset',
    width: '8.85em',

    '&:focus': {
      outline: 'unset',
    },
    '&:hover': {
      backgroundColor: theme.colors.gray[100],
    },
  },
  toggleButtonSelected: {
    backgroundColor: `${theme.palette.background.default} !important`,
    color: `${theme.palette.text.secondary} !important`,
  },
  toggleButtonGroup: {
    backgroundColor: theme.palette.divider,
    borderRadius: '1.5em',
    padding: '.25em 0',
  },
}))

export default ImageToggle
